import styled from 'styled-components';

function Loading() {

    const Load = styled.div`
     width: 45px;
     height: 45px;
     border-radius: 50%;
     border: 6px solid #0000;
     border-right-color: var(--color-primary-light-purple);
     position: relative;
     animation: s4 1s infinite linear;
     

     &:after {
        content: "";
    position: absolute;
    inset:-4px;
    border-radius: 50%;
    border:inherit;
    animation:inherit;
    animation-duration: 2s;
    animation-duration: 4s;
      }

      @keyframes s4 {
        100% {transform: rotate(1turn)}
      }
       `;
 
    return (
      <>
       <center>Waiting...<Load/> </center> 
      </>
    );
  }
  
  export default Loading;
  
  
  